import Vue from 'vue'
import VueRouter from 'vue-router'
import BasicForm from '../views/BasicForm.vue'
import Articles from '../views/Articles.vue'
import Address from '../views/Address.vue'
import Summary from '../views/Summary.vue'
import Signin from '../views/Signin.vue'
import Verify from '../views/Verify.vue'
import Confirmation from '../views/Confirmation.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'BasicForm',
    component: BasicForm
  },
  {
    path: '/articles',
    name: 'Articles',
    component: Articles
  },
  {
    path: '/address',
    name: 'Address',
    component: Address
  },
  {
    path: '/signin',
    name: 'Signin',
    component: Signin
  },
  {
    path: '/summary',
    name: 'Summary',
    component: Summary
  },
  {
    path: '/verify',
    name: 'Verify',
    component: Verify
  },
  {
    path: '/confirmation',
    name: 'Confirmation',
    component: Confirmation
  }
]

const router = new VueRouter({
  routes
})

export default router
